// extracted by mini-css-extract-plugin
export var pageContactForm = "page-contact-module--page-contact__form--pTcET";
export var pageContactInfo = "page-contact-module--page-contact__info--ls6iT";
export var pageContactLocation = "page-contact-module--page-contact__location--Fi1Rc";
export var pageContactPage = "page-contact-module--page-contact__page--gx-eb";